import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import classNames from 'classnames';

import './accordion.scss';

class Accordion extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            expanded: false,
        };
    }

    toggleExpandedState = () => {
        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const { expanded } = this.state;
        const { header, children } = this.props;

        return (
            <section className="cmn-accordion ui-accordion__row">
                <button
                    className={classNames(
                        'ui-accordion__header',
                        { 'ui-accordion__header_active': expanded },
                    )}
                    onClick={this.toggleExpandedState}
                >
                    <h2 className="ui-accordion__title">{header}</h2>
                    <Svg
                        iconName="minus"
                        size="Medium"
                        className="accordionMinus ui-accordion__arrow tableShowIcon"
                    />
                    <Svg
                        iconName="plus"
                        size="Medium"
                        className="accordionPlus ui-accordion__arrow tableShowIcon"
                    />
                </button>
                {expanded &&
                    <div className="ui-accordion__content">
                        {children}
                    </div>
                }
            </section>
        );
    }
}

Accordion.propTypes = {
    header: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default Accordion;



// WEBPACK FOOTER //
// ./~/rp-react-common/src/Accordion/Accordion.jsx